



















































































































































































































































































































import { Component, Ref, Vue } from "vue-property-decorator"
import moment from "moment-timezone"
import { primaryColor } from "@/plugins/vuetify"
import { gerarPdfDashboardDeAcaoDeCashback, svgParaImagem } from "@/shareds/dashboard/gerar-pdf-dashboard-de-acao-de-cashback"
import { FindCashbackUseCase } from "@/usecases"
import { DashboardDaAcaoDobro, DashboardDaAcaoData, FaixaDaDistribuicaoDashboard, PontoDaSerieDashboard } from "@/models/DashboardDaAcaoDeCashback"
import { ResumoDaMetaDeAcaoDeCashback } from "@/models/MetaDeAcaoDeCashback"
import AlertModule from "@/store/vuex/aplicacao/AlertModule"

type TipoDeDashboard = "dobro" | "data"

interface AcaoDoDashboard {
	id: string
	tipo: TipoDeDashboard
	nome?: string
	descricao?: string
	periodo?: string
	ativa?: boolean
	inicio?: string
	fim?: string
}

interface DadosDoRelatorio {
	icon: string
	iconBg: string
	iconColor: string
	name: string
	desc: string
	statusLabel: string
	statusIcon: string
	statusBg: string
	statusColor: string
	period: string
	efeitoTitle: string
	origValor?: string
	origPct?: string
	dobroValor?: string
	dobroPct?: string
	vencNovo?: string
	reativados?: string
	kpi1Label: string
	kpi1: string
	kpi2Label: string
	kpi2: string
	kpi1Icone: string
	kpi2Icone: string
	vendasLabel: string
	vendas: string
	conversao: string
	receita: string
	ticket: string
	chartRange: string
	cashColor: string
	vendasColor: string
	cashInvestido: string
	cashRestante: string
	vendasTotal: string
	idxColor: string
	idxCurrent: string
	start: string
	end: string
	today: string
	dates: string[]
	cashSeries: number[]
	vendasSeries: number[]
	idxSeries: number[]
	distBuckets: string[]
	distPcts: number[]
	distTotal: number
	distCounts?: number[]
}

// Dados mockados apenas para montar o layout — nenhuma chamada de API por enquanto.
const DADOS: Record<TipoDeDashboard, DadosDoRelatorio> = {
	dobro: {
		icon: "mdi-piggy-bank", iconBg: "#fff4e6", iconColor: "#e69138",
		name: "CashBack Dobrar Dez 2024 Open", desc: "dobrar os cashback do período de 02/12 a 15/12 open",
		statusLabel: "Vigente", statusIcon: "mdi-check-circle", statusBg: "#e7f4ec", statusColor: "#1e7d46",
		period: "01/07/2025 – 30/07/2025",
		efeitoTitle: "Efeito do dobro de cashback",
		origValor: "R$ 12.450,00", origPct: "5%", dobroValor: "R$ 24.900,00", dobroPct: "10%",
		kpi1Label: "Cashback consumido", kpi1: "R$ 7.420,00",
		kpi2Label: "Cashbacks gerados", kpi2: "396",
		kpi1Icone: "mdi-cash-multiple", kpi2Icone: "mdi-ticket-confirmation",
		vendasLabel: "Vendas convertidas", vendas: "118", conversao: "29,8%",
		receita: "R$ 19.850,00", ticket: "R$ 168,22",
		chartRange: "01/07 a 09/07 · em andamento",
		cashColor: "#e69138", vendasColor: "#1e7d46",
		cashInvestido: "R$ 24.900,00", cashRestante: "R$ 17.480,00", vendasTotal: "R$ 19.850,00",
		idxColor: "#1e7d46", idxCurrent: "2,1×",
		start: "01/07/2025", end: "30/07/2025", today: "09/07/2025",
		dates: ["01/07/2025", "02/07/2025", "04/07/2025", "05/07/2025", "07/07/2025", "09/07/2025"],
		cashSeries: [24900, 23400, 21600, 19900, 18500, 17480],
		vendasSeries: [0, 3000, 7500, 12000, 16400, 19850],
		idxSeries: [1.2, 1.5, 1.7, 1.9, 2.0, 2.1],
		distBuckets: ["1–1,5×", "1,5–2×", "2–2,5×", "2,5–3×", "3×+"],
		distPcts: [22, 33, 29, 11, 5], distTotal: 118,
	},
	data: {
		icon: "mdi-calendar-refresh", iconBg: "#eef5fe", iconColor: "#2a78d6",
		name: "reativação_fev_25_open", desc: "cashback expirado do dia 01/01/2025 a 05/02/2025",
		statusLabel: "Vigente", statusIcon: "mdi-check-circle", statusBg: "#e7f4ec", statusColor: "#1e7d46",
		period: "01/07/2025 – 30/07/2025",
		efeitoTitle: "Efeito da reativação de cashback",
		vencNovo: "30/07/2025",
		kpi1Label: "Cashback reativado", kpi1: "R$ 18.320,00",
		kpi2Label: "Cashbacks reativados", kpi2: "927",
		kpi1Icone: "mdi-cash-multiple", kpi2Icone: "mdi-ticket-confirmation",
		vendasLabel: "Vendas convertidas", vendas: "78", conversao: "8,4%",
		receita: "R$ 14.200,00", ticket: "R$ 182,05",
		chartRange: "01/07 a 09/07 · em andamento",
		cashColor: "#2a78d6", vendasColor: "#1e7d46",
		cashInvestido: "R$ 18.320,00", cashRestante: "R$ 12.900,00", vendasTotal: "R$ 14.200,00",
		idxColor: "#2a78d6", idxCurrent: "2,1×",
		start: "01/07/2025", end: "30/07/2025", today: "09/07/2025",
		dates: ["01/07/2025", "02/07/2025", "04/07/2025", "05/07/2025", "07/07/2025", "09/07/2025"],
		cashSeries: [18320, 17400, 16200, 14900, 13800, 12900],
		vendasSeries: [0, 2200, 5400, 8600, 11500, 14200],
		idxSeries: [1.3, 1.6, 1.8, 1.9, 2.0, 2.1],
		distBuckets: ["1–1,5×", "1,5–2×", "2–2,5×", "2,5–3×", "3×+"],
		distPcts: [18, 28, 32, 15, 7], distTotal: 78,
	},
}

@Component
export default class DashboardDaAcaoDeCashback extends Vue {
	@Ref() svgConsumo!: SVGSVGElement
	@Ref() svgIndice!: SVGSVGElement
	@Ref() svgDistribuicao!: SVGSVGElement

	findCashbackUseCase = new FindCashbackUseCase()

	mostra = false
	carregando = false
	gerandoPdf = false
	tipo: TipoDeDashboard = "dobro"
	acao: AcaoDoDashboard | null = null
	resumoDobro: DashboardDaAcaoDobro | null = null
	resumoData: DashboardDaAcaoData | null = null
	resumoMeta: ResumoDaMetaDeAcaoDeCashback | null = null

	mostrar(acao: AcaoDoDashboard) {
		this.acao = acao
		this.tipo = acao.tipo === "dobro" ? "dobro" : "data"
		this.resumoDobro = null
		this.resumoData = null
		this.resumoMeta = null
		this.mostra = true
		this.carregarDashboard()
	}

	esconder() {
		this.mostra = false
		this.$emit("voltar")
	}

	async baixarPdf() {
		if (!this.acao) return
		try {
			this.gerandoPdf = true
			const relatorio = this.rep
			const [imagemConsumo, imagemIndice, imagemDistribuicao] = await Promise.all([
				svgParaImagem(this.svgConsumo),
				svgParaImagem(this.svgIndice),
				svgParaImagem(this.svgDistribuicao),
			])

			const efeitos = this.tipo === "dobro"
				? [
					{ rotulo: "Cashback original (padrão)", valor: relatorio.origValor || "", cor: "#5A5A62" },
					{ rotulo: "Cashback com dobro aplicado", valor: relatorio.dobroValor || "", cor: "#E69138" },
				]
				: [
					{ rotulo: "Cashbacks reativados (R$)", valor: relatorio.reativados || "", cor: "#5A5A62" },
					{ rotulo: "Novo vencimento (único)", valor: relatorio.vencNovo || "", cor: "#1A56B0", observacao: "Todos reativados para a mesma data" },
				]

			await gerarPdfDashboardDeAcaoDeCashback({
				corPrimaria: primaryColor(),
				nome: relatorio.name,
				descricao: relatorio.desc,
				periodo: relatorio.period,
				statusLabel: relatorio.statusLabel,
				statusColor: relatorio.statusColor,
				efeitoTitulo: relatorio.efeitoTitle,
				efeitos,
				kpis: [
					{ titulo: relatorio.kpi1Label, valor: relatorio.kpi1 },
					{ titulo: relatorio.kpi2Label, valor: relatorio.kpi2 },
					{ titulo: relatorio.vendasLabel, valor: relatorio.vendas, subtitulo: `${relatorio.conversao} de conversão` },
					{ titulo: "Receita convertida", valor: relatorio.receita, subtitulo: `Ticket médio ${relatorio.ticket}` },
				],
				graficos: [
					{
						titulo: "Consumo do cashback × vendas acumuladas",
						subtitulo: `Em R$ · ${relatorio.chartRange}`,
						destaques: [
							{ rotulo: "Vendas acumuladas", valor: relatorio.vendasTotal, cor: "#1E7D46" },
							{ rotulo: "Cashback investido", valor: relatorio.cashInvestido, cor: relatorio.cashColor },
							{ rotulo: "Restante a consumir", valor: relatorio.cashRestante, cor: "#3C3C43" },
						],
						imagem: imagemConsumo,
					},
					{
						titulo: "Índice de aproveitamento do cashback",
						subtitulo: "Teto de cashback permitido na compra ÷ cashback usado. 1,0× = usou o máximo permitido; quanto maior, menos do teto foi usado",
						destaques: [{ rotulo: "Índice médio da ação", valor: relatorio.idxCurrent, cor: relatorio.idxColor }],
						imagem: imagemIndice,
					},
					{
						titulo: "Distribuição dos clientes por índice de aproveitamento",
						subtitulo: "% de clientes por faixa de índice, de 0,5× em 0,5× (3× ou mais agrupados)",
						destaques: [{ rotulo: "Total de clientes", valor: String(this.dist.total), cor: relatorio.idxColor }],
						imagem: imagemDistribuicao,
					},
				],
				meta: this.metaParaPdf(),
				geradoEm: moment.tz("America/Sao_Paulo").format("DD/MM/YYYY [às] HH:mm"),
				tipo: this.tipo,
				statusBg: relatorio.statusBg,
			})
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.gerandoPdf = false
		}
	}

	async carregarDashboard() {
		if (!this.acao) return
		try {
			this.carregando = true
			this.carregarMeta()
			if (this.tipo === "dobro") {
				this.resumoDobro = await this.findCashbackUseCase.buscarDashboardDaAcaoDeDobro(this.acao.id)
			} else {
				this.resumoData = await this.findCashbackUseCase.buscarDashboardDaAcaoDeData(this.acao.id)
			}
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	metaParaPdf() {
		const meta = this.metaDoDashboard
		if (!meta) return undefined
		return {
			percentual: meta.percentual,
			cor: meta.cor,
			situacao: meta.chipLabel,
			acimaDaMeta: meta.superada ? meta.percentual - 100 : 0,
			meta: meta.meta,
			realizado: meta.realizado,
			falta: meta.falta,
			diasRestantes: meta.diasRestantes,
			projecao: meta.projecao,
			corProjecao: meta.corProjecao,
			percentualProjecao: meta.percentualProjecao,
		}
	}

	async carregarMeta() {
		if (!this.acao) return
		try {
			this.resumoMeta = await this.findCashbackUseCase.findMetaDaAcaoDeCashback(this.acao.id)
		} catch (error: any) {
			this.resumoMeta = null
		}
	}

	get metaDoDashboard() {
		const resumo = this.resumoMeta
		if (!resumo || !resumo.valorMeta) return null

		const formatoBr = "DD/MM/YYYY"
		const valorMeta = resumo.valorMeta
		const realizado = resumo.valorAtingido || 0
		const percentual = Math.round(realizado / valorMeta * 100)
		const superada = percentual >= 100

		const inicio = this.acao && this.acao.inicio ? moment(this.acao.inicio, formatoBr) : null
		const fim = this.acao && this.acao.fim ? moment(this.acao.fim, formatoBr) : null
		const hoje = this.hojeEmBrasilia()
		const periodoValido = !!inicio && !!fim && inicio.isValid() && fim.isValid()
		const encerrada = !!fim && hoje.isAfter(fim, "day")

		let projecao = realizado
		let diasRestantes = "ação encerrada"
		if (inicio && fim && periodoValido && !encerrada) {
			const diasTotais = Math.max(fim.diff(inicio, "days") + 1, 1)
			const diasDecorridos = Math.min(Math.max(hoje.diff(inicio, "days") + 1, 0), diasTotais)
			projecao = diasDecorridos > 0 ? this.projetarVendas(realizado, diasDecorridos, diasTotais) : 0
			const restantes = Math.max(fim.diff(hoje.clone().startOf("day"), "days"), 0)
			diasRestantes = restantes === 1 ? "1 dia restante" : `${restantes} dias restantes`
		}
		const percentualProjecao = Math.round(projecao / valorMeta * 100)

		const corDoPercentual = (valor: number) => valor >= 100 ? "#1e7d46" : valor >= 50 ? "#e69138" : "#d9534f"
		const cor = corDoPercentual(percentual)

		let chipLabel = "Em andamento"
		let chipIcone = "mdi-trending-up"
		let chipBg = percentual >= 50 ? "#fdf1e2" : "#fdecec"
		let chipCor = cor
		if (superada) {
			chipLabel = "Meta superada"
			chipIcone = "mdi-trophy"
			chipBg = "#1e7d46"
			chipCor = "#ffffff"
		} else if (encerrada) {
			chipLabel = "Meta não atingida"
			chipIcone = "mdi-flag-off"
		}

		return {
			percentual,
			superada,
			cor,
			meta: this.formatarMoeda(valorMeta),
			realizado: this.formatarMoeda(realizado),
			falta: this.formatarMoeda(Math.max(valorMeta - realizado, 0)),
			projecao: this.formatarMoeda(projecao),
			percentualProjecao,
			corProjecao: corDoPercentual(percentualProjecao),
			diasRestantes,
			chipLabel,
			chipIcone,
			chipBg,
			chipCor,
		}
	}

	get cashbackDaAcao(): { disponibilizado: number; consumido: number } | null {
		if (this.tipo === "dobro" && this.resumoDobro) {
			return {
				disponibilizado: (this.resumoDobro.valorTotalCashbacksAfetados || 0) + (this.resumoDobro.valorTotalCashbacksGeradosEmDobro || 0),
				consumido: this.resumoDobro.valorTotalCashbackConsumido || 0,
			}
		}
		if (this.tipo === "data" && this.resumoData) {
			return {
				disponibilizado: this.resumoData.valorTotalCashbacksAfetados || 0,
				consumido: this.resumoData.valorTotalCashbackConsumido || 0,
			}
		}
		return null
	}

	projetarVendas(realizado: number, diasDecorridos: number, diasTotais: number): number {
		const cashback = this.cashbackDaAcao
		if (!cashback || cashback.consumido <= 0) return realizado
		const restanteDeCashback = Math.max(cashback.disponibilizado - cashback.consumido, 0)
		const consumoPorDia = cashback.consumido / diasDecorridos
		const consumoAdicional = Math.min(restanteDeCashback, consumoPorDia * (diasTotais - diasDecorridos))
		const vendasPorCashback = realizado / cashback.consumido
		return realizado + consumoAdicional * vendasPorCashback
	}

	get temDados(): boolean {
		return this.tipo === "dobro" ? !!this.resumoDobro : !!this.resumoData
	}

	get rep(): DadosDoRelatorio {
		const base = DADOS[this.tipo] || DADOS.dobro
		const relatorio: DadosDoRelatorio = { ...base }

		if (this.acao) {
			relatorio.name = this.acao.nome || base.name
			relatorio.desc = this.acao.descricao || base.desc
			relatorio.period = this.acao.periodo || base.period

			const vigente = this.acao.ativa !== false
			relatorio.statusLabel = vigente ? "Vigente" : "Encerrada"
			relatorio.statusIcon = vigente ? "mdi-check-circle" : "mdi-close-circle"
			relatorio.statusBg = vigente ? "#e7f4ec" : "#f2f2f4"
			relatorio.statusColor = vigente ? "#1e7d46" : "#8a8a92"
		}

		// Dados reais vindos do backend sobrescrevem os campos correspondentes.
		if (this.tipo === "dobro" && this.resumoDobro) {
			const valorOriginal = this.resumoDobro.valorTotalCashbacksAfetados || 0
			const valorGerado = this.resumoDobro.valorTotalCashbacksGeradosEmDobro || 0
			relatorio.origValor = this.formatarMoeda(valorOriginal)
			// "Com dobro aplicado" = valor original + valor gerado em dobro
			relatorio.dobroValor = this.formatarMoeda(valorOriginal + valorGerado)
			const valorConsumido = this.resumoDobro.valorTotalCashbackConsumido || 0
			const totalDisponibilizado = valorOriginal + valorGerado
			relatorio.kpi1Label = "Cashbacks gerados em dobro"
			relatorio.kpi1 = String(this.resumoDobro.quantidadeCashbacksGeradosEmDobro)
			relatorio.kpi1Icone = "mdi-ticket-confirmation"
			relatorio.kpi2Label = "Cashback consumido"
			relatorio.kpi2 = this.formatarMoeda(valorConsumido)
			relatorio.kpi2Icone = "mdi-cash-multiple"
			relatorio.vendasLabel = "Vendas convertidas"
			relatorio.vendas = String(this.resumoDobro.quantidadeVendasConvertidas || 0)
			// Conversão (R$) = consumido / (original + dobro) do cashback disponibilizado pela ação
			relatorio.conversao = this.formatarPercentual(totalDisponibilizado > 0 ? valorConsumido / totalDisponibilizado * 100 : 0)
			// Receita convertida = total das vendas que usaram o cashback da ação (o total da venda já vem com os descontos)
			const totalVendas = this.resumoDobro.valorTotalVendasConvertidas || 0
			const quantidadeVendas = this.resumoDobro.quantidadeVendasConvertidas || 0
			const receitaConvertida = totalVendas
			relatorio.receita = this.formatarMoeda(receitaConvertida)
			// Ticket médio = valor das vendas convertidas / número de vendas convertidas
			relatorio.ticket = this.formatarMoeda(quantidadeVendas > 0 ? totalVendas / quantidadeVendas : 0)
			// Gráfico "Consumo do cashback × vendas acumuladas"
			relatorio.vendasTotal = this.formatarMoeda(receitaConvertida)
			relatorio.cashInvestido = this.formatarMoeda(totalDisponibilizado)
			relatorio.cashRestante = this.formatarMoeda(totalDisponibilizado - valorConsumido)
			const tetoCashback = this.resumoDobro.valorTotalTetoCashback || 0
			const consumidoComTeto = this.resumoDobro.valorTotalCashbackConsumidoComTeto || 0
			const indice = consumidoComTeto > 0 ? tetoCashback / consumidoComTeto : 0
			relatorio.idxCurrent = this.formatarIndice(indice)
			this.preencherGraficos(relatorio, this.resumoDobro.serieDiaria, totalDisponibilizado)
			this.preencherDistribuicao(relatorio, this.resumoDobro.distribuicaoDeClientes)
		}

		if (this.tipo === "data" && this.resumoData) {
			const valorAfetados = this.resumoData.valorTotalCashbacksAfetados || 0
			const valorConsumido = this.resumoData.valorTotalCashbackConsumido || 0
			const totalVendas = this.resumoData.valorTotalVendasConvertidas || 0
			const quantidadeVendas = this.resumoData.quantidadeVendasConvertidas || 0
			const receitaConvertida = totalVendas

			relatorio.vencNovo = this.formatarData(this.resumoData.dataFimAcao)
			relatorio.reativados = this.formatarMoeda(valorAfetados)
			relatorio.kpi1Label = "Cashbacks reativados"
			relatorio.kpi1 = String(this.resumoData.quantidadeCashbacksAfetados || 0)
			relatorio.kpi1Icone = "mdi-ticket-confirmation"
			relatorio.kpi2Label = "Cashback consumido"
			relatorio.kpi2 = this.formatarMoeda(valorConsumido)
			relatorio.kpi2Icone = "mdi-cash-multiple"
			relatorio.vendas = String(quantidadeVendas)
			relatorio.conversao = this.formatarPercentual(valorAfetados > 0 ? valorConsumido / valorAfetados * 100 : 0)
			relatorio.receita = this.formatarMoeda(receitaConvertida)
			relatorio.ticket = this.formatarMoeda(quantidadeVendas > 0 ? totalVendas / quantidadeVendas : 0)
			relatorio.vendasTotal = this.formatarMoeda(receitaConvertida)
			relatorio.cashInvestido = this.formatarMoeda(valorAfetados)
			relatorio.cashRestante = this.formatarMoeda(valorAfetados - valorConsumido)
			const tetoCashback = this.resumoData.valorTotalTetoCashback || 0
			const consumidoComTeto = this.resumoData.valorTotalCashbackConsumidoComTeto || 0
			const indice = consumidoComTeto > 0 ? tetoCashback / consumidoComTeto : 0
			relatorio.idxCurrent = this.formatarIndice(indice)
			this.preencherGraficos(relatorio, this.resumoData.serieDiaria, valorAfetados)
			this.preencherDistribuicao(relatorio, this.resumoData.distribuicaoDeClientes)
		}

		return relatorio
	}

	formatarMoeda(valor: number): string {
		return (valor || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
	}

	formatarPercentual(valor: number): string {
		return (valor || 0).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "%"
	}

	formatarIndice(valor: number): string {
		return (valor || 0).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "×"
	}

	preencherGraficos(relatorio: DadosDoRelatorio, serie: PontoDaSerieDashboard[] | undefined, investido: number) {
		const formatoBr = "DD/MM/YYYY"
		const inicioDaAcao = this.acao && this.acao.inicio && this.acao.inicio !== "- -" ? this.acao.inicio : relatorio.start
		const fimDaAcao = this.acao && this.acao.fim && this.acao.fim !== "- -" ? this.acao.fim : relatorio.end
		const hoje = this.hojeDentroDoPeriodo(inicioDaAcao, fimDaAcao)

		const pontos = (serie || []).map(ponto => {
			const consumido = ponto.consumidoAcumulado || 0
			const consumidoComTeto = ponto.consumidoComTetoAcumulado || 0
			return {
				data: moment(ponto.data, "YYYY-MM-DD").format(formatoBr),
				vendas: ponto.vendasAcumuladas || 0,
				cash: investido - consumido,
				indice: consumidoComTeto > 0 ? (ponto.tetoAcumulado || 0) / consumidoComTeto : 0,
			}
		})

		if (pontos.length === 0) pontos.push({ data: inicioDaAcao, vendas: 0, cash: investido, indice: 0 })

		const ultimo = pontos[pontos.length - 1]
		const dataDeFechamento = hoje || fimDaAcao
		if (moment(ultimo.data, formatoBr).isBefore(moment(dataDeFechamento, formatoBr), "day")) {
			pontos.push({ ...ultimo, data: dataDeFechamento })
		}

		const primeiro = pontos[0]
		if (moment(inicioDaAcao, formatoBr).isBefore(moment(primeiro.data, formatoBr), "day")) {
			pontos.unshift({ data: inicioDaAcao, vendas: 0, cash: investido, indice: primeiro.indice })
		}

		const primeiraData = moment.min(moment(inicioDaAcao, formatoBr), moment(pontos[0].data, formatoBr))
		const ultimaData = moment.max(moment(fimDaAcao, formatoBr), moment(pontos[pontos.length - 1].data, formatoBr))

		const situacaoDaAcao = hoje ? "em andamento" : this.hojeEmBrasilia().isAfter(moment(fimDaAcao, formatoBr), "day") ? "encerrada" : "não iniciada"

		relatorio.start = primeiraData.format(formatoBr)
		relatorio.end = ultimaData.format(formatoBr)
		relatorio.today = hoje
		relatorio.chartRange = `${moment(inicioDaAcao, formatoBr).format("DD/MM")} a ${moment(fimDaAcao, formatoBr).format("DD/MM")} · ${situacaoDaAcao}`
		relatorio.dates = pontos.map(ponto => ponto.data)
		relatorio.vendasSeries = pontos.map(ponto => ponto.vendas)
		relatorio.cashSeries = pontos.map(ponto => ponto.cash)
		relatorio.idxSeries = pontos.map(ponto => ponto.indice)
	}

	preencherDistribuicao(relatorio: DadosDoRelatorio, faixas: FaixaDaDistribuicaoDashboard[] | undefined) {
		const lista = faixas || []
		const total = lista.reduce((soma, faixa) => soma + faixa.quantidade, 0)
		const formatarLimite = (valor: number) => valor.toLocaleString("pt-BR", { maximumFractionDigits: 1 })

		relatorio.distBuckets = lista.map((faixa, i) => {
			if (i === 0) return "< " + formatarLimite(lista[1] ? lista[1].indiceMinimo : 1) + "×"
			if (i === lista.length - 1) return formatarLimite(faixa.indiceMinimo) + "×+"
			return formatarLimite(faixa.indiceMinimo) + "–" + formatarLimite(lista[i + 1].indiceMinimo) + "×"
		})
		relatorio.distCounts = lista.map(faixa => faixa.quantidade)
		relatorio.distPcts = lista.map(faixa => total > 0 ? Math.round(faixa.quantidade / total * 100) : 0)
		relatorio.distTotal = total
	}

	hojeEmBrasilia() {
		return moment(moment.tz("America/Sao_Paulo").format("YYYY-MM-DD"), "YYYY-MM-DD")
	}

	hojeDentroDoPeriodo(inicio: string, fim: string): string {
		const hoje = this.hojeEmBrasilia()
		const dataInicio = moment(inicio, "DD/MM/YYYY")
		const dataFim = moment(fim, "DD/MM/YYYY")
		if (hoje.isBefore(dataInicio, "day") || hoje.isAfter(dataFim, "day")) return ""
		return hoje.format("DD/MM/YYYY")
	}

	formatarData(data: string | null): string {
		if (!data) return "- -"
		return moment(data).subtract(3, "hours").format("DD/MM/YYYY")
	}

	get chart() {
		const r = this.rep
		const x0 = 62, x1 = 806, top = 18, bottom = 200
		const start = this.pd(r.start), end = this.pd(r.end), span = (end - start) || 1
		const xAt = (t: string) => x0 + ((this.pd(t) - start) / span) * (x1 - x0)
		const rawMax = Math.max(...r.cashSeries, ...r.vendasSeries) || 1
		const stepp = Math.pow(10, Math.floor(Math.log10(rawMax)))
		const max = Math.ceil((rawMax * 1.08) / (stepp / 2)) * (stepp / 2)
		const yAt = (v: number) => bottom - (v / max) * (bottom - top)
		const cashPts = r.dates.map((d, i) => ({ x: xAt(d), y: yAt(r.cashSeries[i]) }))
		const vendasPts = r.dates.map((d, i) => ({ x: xAt(d), y: yAt(r.vendasSeries[i]) }))
		const lastX = cashPts[cashPts.length - 1].x
		const vendasPath = this.smooth(vendasPts)
		const yTicks = [0, 1, 2, 3].map(k => {
			const val = max * (k / 3)
			const y = yAt(val)
			return { y: y.toFixed(1), ty: (y + 3.5).toFixed(1), label: this.fmtK(val) }
		})
		const K = 6
		const xLabels = Array.from({ length: K }, (_, i) => ({
			label: this.ddmm(start + span * (i / (K - 1))),
			x: (x0 + (i / (K - 1)) * (x1 - x0)).toFixed(1),
		}))
		return {
			yTicks, xLabels,
			cashPath: this.smooth(cashPts), vendasPath,
			vendasArea: vendasPath + "L" + lastX.toFixed(1) + "," + bottom + "L" + x0 + "," + bottom + "Z",
			cashEndX: cashPts[cashPts.length - 1].x.toFixed(1), cashEndY: cashPts[cashPts.length - 1].y.toFixed(1),
			vendasEndX: vendasPts[vendasPts.length - 1].x.toFixed(1), vendasEndY: vendasPts[vendasPts.length - 1].y.toFixed(1),
			hojeX: r.today ? xAt(r.today).toFixed(1) : null,
		}
	}

	get indice() {
		const r = this.rep
		const x0 = 62, x1 = 806, top = 18, bottom = 178
		const start = this.pd(r.start), end = this.pd(r.end), span = (end - start) || 1
		const xAt = (t: string) => x0 + ((this.pd(t) - start) / span) * (x1 - x0)
		const maiorIndice = r.idxSeries.reduce((maior, valor) => Number.isFinite(valor) ? Math.max(maior, valor) : maior, 0)
		const passoDoEixo = maiorIndice > 3 ? this.passoDoEixo(maiorIndice / 4) : 1
		const maxY = maiorIndice > 3 ? Math.ceil(maiorIndice / passoDoEixo) * passoDoEixo : 3
		const yAt = (v: number) => bottom - ((Number.isFinite(v) ? v : 0) / maxY) * (bottom - top)
		const pts = r.dates.map((d, i) => ({ x: xAt(d), y: yAt(r.idxSeries[i]) }))
		const lastX = pts[pts.length - 1].x
		const linePath = this.smooth(pts)
		const yTicks: { y: string; ty: string; label: string }[] = []
		for (let k = 0; k <= maxY; k += passoDoEixo) {
			const y = yAt(k)
			yTicks.push({ y: y.toFixed(1), ty: (y + 3.5).toFixed(1), label: k.toLocaleString("pt-BR") + "×" })
		}
		const K = 6
		const xLabels = Array.from({ length: K }, (_, i) => ({
			label: this.ddmm(start + span * (i / (K - 1))),
			x: (x0 + (i / (K - 1)) * (x1 - x0)).toFixed(1),
		}))
		const refY = yAt(1)
		return {
			yTicks, xLabels, linePath,
			area: linePath + "L" + lastX.toFixed(1) + "," + bottom + "L" + x0 + "," + bottom + "Z",
			endX: pts[pts.length - 1].x.toFixed(1), endY: pts[pts.length - 1].y.toFixed(1),
			refY: refY.toFixed(1), refTy: (refY - 5).toFixed(1),
			hojeX: r.today ? xAt(r.today).toFixed(1) : null,
		}
	}

	get dist() {
		const r = this.rep
		const x0 = 48, x1 = 806, top = 16, bottom = 178
		const n = r.distBuckets.length
		const maxY = Math.max(10, Math.ceil(Math.max(...r.distPcts) / 10) * 10)
		const yAt = (p: number) => bottom - (p / maxY) * (bottom - top)
		const bucketW = (x1 - x0) / n, bw = bucketW * 0.6
		const bars = r.distBuckets.map((label, i) => {
			const cx = x0 + i * bucketW + bucketW / 2
			const y = yAt(r.distPcts[i])
			return {
				label, pct: r.distPcts[i], count: r.distCounts ? r.distCounts[i] : Math.round(r.distPcts[i] / 100 * r.distTotal),
				x: (cx - bw / 2).toFixed(1), y: y.toFixed(1), w: bw.toFixed(1), h: (bottom - y).toFixed(1),
				cx: cx.toFixed(1), valY: (y - 6).toFixed(1), cntY: (y + 16).toFixed(1),
			}
		})
		const yTicks = [0, 1, 2, 3].map(k => {
			const val = maxY * (k / 3)
			const y = yAt(val)
			return { y: y.toFixed(1), ty: (y + 3.5).toFixed(1), label: Math.round(val) + "%" }
		})
		return { bars, yTicks, total: r.distTotal }
	}

	passoDoEixo(valor: number): number {
		const base = Math.pow(10, Math.floor(Math.log10(valor)))
		return [1, 2, 5, 10].map(multiplo => multiplo * base).find(passo => passo >= valor) as number
	}

	pd(s: string): number {
		const [d, m, y] = s.split("/").map(Number)
		return Date.UTC(y, m - 1, d)
	}

	ddmm(t: number): string {
		const d = new Date(t)
		return String(d.getUTCDate()).padStart(2, "0") + "/" + String(d.getUTCMonth() + 1).padStart(2, "0")
	}

	fmtK(v: number): string {
		return v >= 1000
			? "R$ " + (v / 1000).toFixed(v % 1000 === 0 ? 0 : 1).replace(".", ",") + "k"
			: "R$ " + Math.round(v)
	}

	smooth(p: { x: number; y: number }[]): string {
		let d = "M" + p[0].x.toFixed(1) + "," + p[0].y.toFixed(1)
		for (let i = 0; i < p.length - 1; i++) {
			const p0 = p[i - 1] || p[i], p1 = p[i], p2 = p[i + 1], p3 = p[i + 2] || p[i + 1]
			const c1x = p1.x + (p2.x - p0.x) / 6, c1y = p1.y + (p2.y - p0.y) / 6
			const c2x = p2.x - (p3.x - p1.x) / 6, c2y = p2.y - (p3.y - p1.y) / 6
			d += "C" + c1x.toFixed(1) + "," + c1y.toFixed(1) + " " + c2x.toFixed(1) + "," + c2y.toFixed(1) + " " + p2.x.toFixed(1) + "," + p2.y.toFixed(1)
		}
		return d
	}
}
